export default __webpack_public_path__ + "static/media/loading-transp.c7d9f081.gif";